/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { getCommandIntelligenceTokens } from '../../theme/commandIntelligenceTokens';

/**
 * @param {import('@mui/material').Theme & { validateMode?: Function }} theme
 * @param {{ anchor?: string, isMobile?: boolean }} options
 */
export const getCommandIntelligenceDrawerPaperSx = (theme, { anchor = 'right', isMobile = false } = {}) => {
  const tokens = getCommandIntelligenceTokens(theme);

  const borderStyle = `1px solid ${tokens.borderSubtle}`;

  const innerBorder = (() => {
    if (isMobile) {
      return { borderTop: borderStyle };
    }

    if (anchor === 'right') {
      return { borderLeft: borderStyle };
    }

    if (anchor === 'left') {
      return { borderRight: borderStyle };
    }

    if (anchor === 'bottom') {
      return { borderTop: borderStyle };
    }

    if (anchor === 'top') {
      return { borderBottom: borderStyle };
    }

    return {};
  })();

  const cornerRadius = (() => {
    if (isMobile || anchor === 'bottom') {
      return {
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
      };
    }

    if (anchor === 'top') {
      return {
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20,
      };
    }

    return {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    };
  })();

  return {
    ...(isMobile
      ? {
          width: '100%',
          height: '85vh',
        }
      : {}),
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    fontFamily: tokens.fontStack,
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    background: tokens.canvasGradient,
    boxShadow: tokens.elevationDrawer,
    ...innerBorder,
    ...cornerRadius,
  };
};
